import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  mt: {
    marginTop: '10px',
  },
  appBar: {
    color: '#0A688D',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: '0 0 0 0 #fff',
    borderBottom: '1px solid #ccc',
  },
  indicator: {
    backgroundColor: 'white',
    borderTop: '1px solid #333',
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 720,
    background: '#fff',
    border: '2px solid #ccc',
    padding: 20,
    height: '85%',
    overflow: 'hidden',
  },
  btn: {
    backgroundColor: '#0A688D',
    color: '#fff !important',
    padding: '6px 32px !important',

    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  buttonGrey: {
    backgroundColor: '#797979',

    '&:hover': {
      backgroundColor: '#797979',
    },
  },
  buttonMargin: {
    marginLeft: '10px',
  },
  dialogTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
  },
})
